<template>
  <div>
    <h4
      class="clickable"
      @click="
        elementMouseleave();
        open = !open;
      "
      @mouseover="elementMouseover()"
      @mouseleave="elementMouseleave()"
    >
      {{ element.name }}
    </h4>
    <template v-if="open">
      <div
        v-for="property in element.properties"
        v-bind:key="element.name + '-' + property"
      >
        <b-row v-if="property.includes('color')" style="width: 350px">
          <b-col
            cols="auto"
            class="ml-3 clickable"
            @mouseover="propertyMouseover(property)"
            @mouseleave="propertyMouseleave(property)"
            >{{ property }}</b-col
          >
          <b-col cols="auto" class="ml-auto">
            <color-selector
              :cssVar="'--' + element.name + '-' + property"
              :initialColor="colorNameToHex(getCssVar(element.name, property))"
            />
          </b-col>
        </b-row>
      </div>
    </template>
  </div>
</template>
<script>
//---- components ---------
import ColorSelector from "./ColorSelector.vue";
//---- mixins -------------
import ColorMixin from "./colors.js";
//---- services -----------
//---- 3rd-parties --------

export default {
  name: "StyleConfigurator",
  components: { ColorSelector },
  mixins: [ColorMixin],
  props: ["element"],
  data() {
    return {
      open: false,
      inital_values: {},
    };
  },
  methods: {
    elementMouseover() {
      if (this.open) return;
      this.invertColor(
        this.element.properties.find((x) => {
          return x.includes("color") && !x.includes("bg-color");
        })
      );
      this.invertColor(
        this.element.properties.find((x) => {
          return x.includes("bg-color");
        })
      );
    },
    elementMouseleave() {
      if (this.open) return;
      this.restoreColor(
        this.element.properties.find((x) => {
          return x.includes("color") && !x.includes("bg-color");
        })
      );
      this.restoreColor(
        this.element.properties.find((x) => {
          return x.includes("bg-color");
        })
      );
    },
    propertyMouseover(property) {
      this.invertColor(property);
    },
    propertyMouseleave(property) {
      this.restoreColor(property);
    },
    restoreColor(prop) {
      if (!prop) return;
      const varName = "--" + this.element.name + "-" + prop;
      const color = this.inital_values[prop];
      if (this.debug) console.log(varName + " restored to " + color);
      document.documentElement.style.setProperty(varName, color);
    },
    invertColor(prop) {
      if (!prop) return;
      if (this.debug) console.log("invertColor for " + prop);
      const varName = "--" + this.element.name + "-" + prop;
      let color = getComputedStyle(document.documentElement).getPropertyValue(
        varName
      );

      color = this.colorNameToHex(color);

      this.inital_values[prop] = color;

      let red = color.substring(1, 3);
      red = parseInt(red, 16);
      if (red < 64 || red > 192) red = 255 - red;
      else if (red < 128) red = 255 - (red - 128);
      else red = red - 128;

      red = red > 10 ? red.toString(16) : "0" + red.toString(16);
      color = "#" + red + color.substring(3);
      if (this.debug)
        console.log(
          varName +
            " inverted from " +
            this.inital_values[prop] +
            " to " +
            color
        );
      document.documentElement.style.setProperty(varName, color);
    },
  },
};
</script>